import React from 'react';
import InlineDotsLoader from './InlineDotsLoader';

/**
 * Specials section placeholder with inline loader
 * Used during preload to show structure while loading
 */
const SpecialsPlaceholder = () => {
	return (
		<div
			className="d-flex flex-column border box box-padding border-neutral-0-alpha-3 rounded my-4 bg-contrast-med"
			data-preload-container="specials-placeholder"
			data-testid="specials-placeholder"
		>
			<div className="d-flex flex-row my-2 text-left ddc-font-size-xsmall">
				<span className="mr-2">Finance Terms</span>
				<span data-preload="finance-terms">
					<InlineDotsLoader className="small" />
				</span>
			</div>
		</div>
	);
};

export default SpecialsPlaceholder;
